<template>
    <div class="eco-part small pt-0">
        <p class="mb-0 p-0 d-inline">
            <span>{{ ecoPartLabel }}</span>
            <slot name="link" />
            <span>{{ privateCopyingLabelText }}
                <a
                    :href="privateCopyingLink"
                    :target="target"
                    class="ob1-link fw-normal pb-0"
                >{{ privateCopyingLinkText }}</a>
            </span>
        </p>
    </div>
</template>

<script>

export default {
    props: {
        ecoPartLabel: {
            type: String,
            required: true
        },
        privateCopyingLabel: {
            type: String,
            default: null
        },
        privateCopyingLinkLabel: {
            type: String,
            required: true
        },
        privateCopyingLink: {
            type: String,
            required: true
        },
        target: {
            type: String,
            required: false,
            default: "_self"
        }
    },
    computed: {
        privateCopyingLabelText: function () {
            return this.privateCopyingLabel ? ` ${this.privateCopyingLabel}` : '.';
        },
        privateCopyingLinkText: function () {
            return this.privateCopyingLabel ? `${this.privateCopyingLinkLabel}.` : '';
        }
    }
}
</script>
